import {GetDefaultIndexWithMerge} from '../../components';
import { useGetShareholdersCommonInfoQuery, useMergeShareholdersMutation } from "../../features/board/boardSlice";
import { ShareholderMerger } from './shareholderMerger';
import {useShareholderRoutes} from './routes';


export {useShareholderRoutes};


export default GetDefaultIndexWithMerge({
  title: "سهامداران",
  query: useGetShareholdersCommonInfoQuery,
  mergeMutation: useMergeShareholdersMutation,
  merger: (mergeCallback) => <ShareholderMerger mergeCallback={mergeCallback} />
});
